<script>
    import * as yup from 'yup';
    import {push} from "svelte-spa-router";
    import {user} from "../auth/auth";

    let awsErrors;
    let errors = {};
    let values = {
        email: "",
        password: ""
    };

    const schema = yup.object().shape({
        email: yup.string().required("Email is required").email("Email is invalid"),
        password: yup.string().required("Password is required")
    });

    const handleSubmit = async () => {
        errors = {};
        try {
            await schema.validate(values, {abortEarly: false})
        } catch (err) {
            errors = err.inner.reduce((acc, err) => {
                return {...acc, [err.path]: err.message};
            }, {});
        }
        if (Object.keys(errors).length === 0) {
            user.signIn(values.email, values.password,
                function signinError(err) {
                    if (err.message === "User is not confirmed."){
                        push('#/verify')
                    }
                    awsErrors = err;
                });
        }
    };

    function handleCredentialResponse(response) {
        // console.log('complete response: ' + response)
        // console.log("Encoded JWT ID token: " + response.credential);
        user.dealWithGoogleMcGoober(response)
        push('/');
    }

    function loadGapi () {
        gapi.load('auth2', function(){
            // Retrieve the singleton for the GoogleAuth library and set up the client.
            var auth2 = gapi.auth2.init({
                client_id: '193184299028-ooobd90ssrt0qkl4utvmvtovbhj7bttd.apps.googleusercontent.com',
                cookiepolicy: 'single_host_origin',
                prompt: 'select_account'
                // Request scopes in addition to 'profile' and 'email'
                //scope: 'additional_scope'
            });
            attachSignin(auth2, document.getElementById('google-button'));
        });
        function attachSignin(auth2, element) {
            auth2.attachClickHandler(element, {},
                function(googleUser) {
                    console.log("Signed in: " + googleUser.getBasicProfile().getName());
                    handleCredentialResponse(googleUser.getBasicProfile())
                }, function(error) {
                    alert(JSON.stringify(error, undefined, 2));
                });
        }
    }

</script>

<div class="signin-page">
    <section use:loadGapi class="google-signin-section">
        <div id="google-button" class="google-signin"><img src="images/g-logo.png"> Sign in with Google</div>
    </section>
    <div class="or-break-wrap">
        <span class="or-break"><h3>or</h3></span>
    </div>
    <section class="form-wrap">
        <form on:submit|preventDefault={handleSubmit}>
            <fieldset class="form-fs">
                <h2 class="fs-title">Login to your account</h2>
                {#if errors.email}
                    <span class="error">{errors.email}</span>
                {/if}
                <input name="email" type="email" bind:value={values.email} placeholder="Email"/>
                {#if errors.password}
                    <span class="error">{errors.password}</span>
                {/if}
                <input name="password" type="password" bind:value={values.password} placeholder="Password"
                       pattern=".*"/>

                {#if awsErrors}
                    <div class="error">{awsErrors.message}</div>
                {/if}

                <button class="form-button" type="submit">Submit</button>
            </fieldset>
        </form>
    </section>
    <div class="or-break-wrap">
        <span class="or-break"><h3>or</h3></span>
    </div>

    <section class="sign-up">
        <div class="sign-up-button" on:click={() => push('#/register')}><i class="far fa-envelope-open"
                                                                           style="margin-right: 1vw"></i> Sign up with
            Email
        </div>
    </section>

</div>

<style>
    .signin-page {
        margin-top: 8vw;
        margin-inline: 12vw;
        margin-bottom: 0;
        padding-bottom: 10vh;
    }
    .form-wrap {
        background-color: #202020;
        color: #FBF8FE;
        border-radius: 6px;
    }
    .form-fs {
        font-size: 3vw;
        font-family: "Poppins", "Arial", "Helvetica Neue", sans-serif;
        padding-top: 0;
        padding-left: 7vw;
        padding-right: 7vw;
        border: none;
    }
    .form-button {
        margin-top: 4vh;
        border-radius: 6px;
        color: #0B8185;
    }
    .form-button:hover {
        cursor: pointer;
    }
    .or-break-wrap {
        display: flex;
        flex: 1;
        width: 100%;
        margin-top: 1vh;
        position: relative;
    }
    .or-break {
        text-align: center;
        width: 100%;
        color: #FBF8FE;
        padding: 3vh;
        font-size: 2vh;
    }
    .or-break::after {
        content: '';
        width: 80%;
        border-bottom: solid 1px rgba(255, 255, 255, 0.2);
        position: absolute;
        left: 10%;
        top: 52%;
        z-index: 1;
    }
    h3 {
        background-color: #1D1313;
        width: auto;
        display: inline-block;
        z-index: 3;
        padding: 0 20px 0 20px;
        color: white;
        position: relative;
        font-family: calibri,serif;
        font-weight: lighter;
        margin: 0;
    }
    .sign-up {
        background-color: #202020;
        color: #FBF8FE;
        width: 100%;
        height: 6vh;
    }
    .sign-up-button {
        display: flex;
        justify-content: center;
        text-align: center;
        height: 100%;
        line-height: 100%;
        padding-top: 3vh;
        background-color: #E5394F;
        outline: none;
        font-size: 3vh;
        border-radius: 6px;
    }
    .sign-up:hover {
        cursor: pointer;
    }
    .google-signin-section {
        width: 100%;
        height: 6vh;
    }
    .google-signin-section:hover {
        cursor: pointer;
    }
    .google-signin {
        font-family: 'Roboto', sans-serif;
        display: flex;
        justify-content: center;
        text-align: center;
        height: 100%;
        line-height: 100%;
        padding-top: 3vh;
        background-color: #ffffff;
        outline: none;
        font-size: 3vh;
        border-radius: 6px;
    }
    .google-signin img {
        text-align: center;
        margin-top: -1vh;
        margin-bottom: 1vh;
        padding-bottom: 1vh;
        padding-right: 2vh;
        width: 5vh;
        height: 5vh;
    }

    .error {
        display: flex;
        flex: 1;
        font-size: 1.5vw;
        color: #E5394F;
    }

    input {
        width: 100%;
        padding: 5px 0;
        font-size: 4vw;
        color: #ccc;
        background: transparent;
        outline: none;
        border: none;
        margin: 0 0 33px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }
</style>